/**
 * Helper function to identify the type of object that are included in a list of items.
 *
 * This function can be used by Views with DataTables that contain various types, e.g.
 *   - Glossary (which contain both Entities & Attributes)
 *   - Attributes (which contain both Attributes & Attribute Values)
 *
 * @param {Array} items - List of items, where each item is an object that is expected to have a property `object_name`
 * @param {string} defaultObjectName
 * @returns {string}
 */
export const getObjectNameFromSelection = (items, defaultObjectName) => {
  let objectName;

  for (let i = 0; i < items.length; i++) {
    if (!items[i].object_name) {
      // No object_name is present
      objectName = defaultObjectName;
      break;
    }

    // Check selection what asset types it contains
    if (!objectName || items[i].object_name === objectName) {
      // One asset type
      objectName = items[i].object_name;
    } else {
      // More than one asset type
      objectName = 'mixed';
      break;
    }
  }

  return objectName;
};
